/** True when a stored file should use PDF preview (view + download icons). */
export function isPdfFile(
  fileName: string,
  contentType?: string | null,
): boolean {
  if (contentType != null && contentType.toLowerCase().includes('pdf')) {
    return true
  }
  return fileName.toLowerCase().endsWith('.pdf')
}
